import { render, staticRenderFns } from "./EventCardLinkButton.vue?vue&type=template&id=4475f6f7&scoped=true"
import script from "./EventCardLinkButton.vue?vue&type=script&lang=js"
export * from "./EventCardLinkButton.vue?vue&type=script&lang=js"
import style0 from "./EventCardLinkButton.vue?vue&type=style&index=0&id=4475f6f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4475f6f7",
  null
  
)

export default component.exports